import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    Form,
    FormControl,
    InputGroup,
    Modal,
    Nav,
    Tab,
    ToggleButton,
} from "react-bootstrap";
import moment from "moment";
import CotisationSel from "./CotisationSel";
import CotisationChoixSel from "./CotisationChoixSel";
import NewDropdown from "./NewDropdown";

const AdherentNewUpdate = ({
    handleSaveAdherent,
    blocs,
    champs,
    cotisation,
    cotisation2,
    setCotisation,
    setCotisation2,
    adherent,
    code,
}) => {
    const [editedAdherent, setEditedAdherent] = useState(adherent ? adherent : {
        prenom_adherent: "",
        nom_adherent: "",
        adresse1: "",
        adresse2: "",
        code_postal: "",
        ville: "",
        telephone: "",
        numero_de_portable: "",
        e_mail_1: "",
        e_mail_2: "",
        e_mail_3: "",
        civilite: "M",
        numero_de_dpt: "",
        numero_client: "",
        region: "",
        nom_de_l_entreprise: "",
        siret: "",
        numero_tva_intracommunautaire: "",
        code_ape_ou_naf: "4519 Z",
        forme_juridique_de_la_societe: "SCS",
        montant_du_capital: 0,
        code_metier: "",
        nbre_productifs: 1,
        nbre_apprentis: 0,
        total_personnel: 1,
        acces_site_ffc_newsletter: [10, 5].includes(cotisation.id) ? 0 : 1,
        abonne_ffc_expert: [10, 5].includes(cotisation.id) ? 0 : 1,
        abonne_mag_carrosserie: [10, 5].includes(cotisation.id) ? 0 : 1,
        abonne_profession_carrossier: [10, 5].includes(cotisation.id) ? 0 : 1,
        acces_mediateur_consommation: [10, 5].includes(cotisation.id) ? 0 : 1,
        enregistre_site_ffc: "",
        enregistre_site_mediation: "",
        reseau: "",
        adh_depuis: "",
        annee_de_cotisation: 0,
        date_paiement: "",
        cotisation_nationale_t1: 0,
        cotisation_reseau: 0,
        cotisation_regionale: 0,
        cotisation_3_ans: "",
        mode_de_paiement: "",
        paiement_en_x_fois: 1,
        cnpa: "",
        fnaa: "",
        autre: "",
        cotisation_id: 0,
        numero_de_feuille_de_cotisation: 0,
        ou_numero_de_feuille_de_cotisation: 0,
        has_tribu: 1,
        date_de_reglement: "",
        fin_periode: "",
        montant_tribu_regle_t2: 0,
        moyen_de_paiement: "",
        identifiant_tribu: "",
        has_siv: 1,
        date_de_reglement_siv: "",
        fin_periode_siv: "",
        montant_regle_siv: 0,
        moyen_de_paiement_siv: "",
        paiement_en_x_fois_siv: 1,
        membre_bureau_ffc: 0,
        membre_conseil_national: 0,
        membres_conseil_admin: 0,
        titre: "",
        choix_id: "",
        paiement_montant: 0,
        tribu_montant: cotisation.tribu_montant,
        siv_montant: cotisation.siv_montant,
        code: "",
        bic: "",
        iban: "",
        bictmp: "",
        ibantmp: "",
        rum: "",
        anneeSel: "",
    });

    const [villes, setVilles] = useState([]);
    const [showVilles, setShowVilles] = useState(false);

    const url = localStorage.getItem('url');

    const getCp = (cp) => {
        fetch(`${url}GetVilles/${cp}`)
            .then((response) => response.json())
            .then((data) => {
                console.log("Réponse du serveur:", data);
                let res = data.data;
                setVilles(res);
                if (res.length === 1)
                    setEditedAdherent({ ...editedAdherent, ville: res[0] ? res[0].localite : "", code_postal: cp });
                else if (res.length > 1) setShowVilles(true);
            })
            .catch((error) => console.error("Erreur:", error));
    };
    const handleVilleSelected = (ville) => {
        setEditedAdherent({ ...editedAdherent, ville: ville });
        setShowVilles(false);
    };

    const [allRequiredFieldsFilled, setAllRequiredFieldsFilled] = useState(false);
    const [dropdown, setDropdown] = useState(
        JSON.parse(localStorage.getItem("dropdown"))
    );
    const [activeKey, setActiveKey] = useState(""); // activeKey par défaut
    const [requiredFields, setRequiredFields] = useState([]);

    const getAnnee = () => {
        let annee = localStorage.getItem("annee");
        console.log("annee", annee);
        if (annee && annee.length === 4) {
            setEditedAdherent({ ...editedAdherent, anneeSel: annee });
        } else
            setTimeout(() => {
                getAnnee();
            }, 2000);
    };
    useEffect(() => {
        getAnnee();
        // handleInputChange('has_tribu', 1);
    }, []);

    // useEffect(() => {
    //     console.log("adherent !!", adherent);
    //     console.log("editedAdherent !!", adherent && adherent.total_personnel>=0);

    //     if (adherent && adherent.total_personnel>=0){
    //         setEditedAdherent(adherent)
    //     }
    //     // setTimeout(() => {
    //     //     setEditedAdherent(adherent)
    //     // }, 1000); ;
    // }, [adherent]);

    useEffect(() => {
        if (code) handleInputChange("code", code);
    }, [code]);

    useEffect(() => {
        verifAllRequiredFieldsFilled(editedAdherent);
    }, [editedAdherent]);

    const saveAdherent = () => {
        let editedAdh = {
            ...editedAdherent,
            date_paiement: moment(editedAdherent.date_paiement).format("YYYY-MM-DD"),
            fin_periode: moment(editedAdherent.fin_periode).format("YYYY-MM-DD"),
            enregistre_site_ffc: moment(editedAdherent.enregistre_site_ffc).format(
                "YYYY-MM-DD"
            ),
            enregistre_site_mediation: moment(
                editedAdherent.enregistre_site_mediation
            ).format("YYYY-MM-DD"),
            date_de_reglement: moment(editedAdherent.date_de_reglement).format(
                "YYYY-MM-DD"
            ),
            date_de_reglement_siv: moment(editedAdherent.date_de_reglement_siv).format(
                "YYYY-MM-DD"
            ),
            fin_periode_siv: moment(editedAdherent.fin_periode_siv).format("YYYY-MM-DD"),
        };
        handleSaveAdherent(editedAdh);
    };

    const verifAllRequiredFieldsFilled = (adherent) => {
        const areAllRequiredFieldsFilled = requiredFields.every((e) => {
            if (typeof adherent[e.field] === "number") {
                return adherent[e.field] > 0;
            } else {
                // console.log(e.field)
                return (
                    adherent[e.field].trim() !== "" &&
                    (!e.longueur ||
                        (e.longueur && adherent[e.field].length === e.longueur))
                );
            }
        });
        setAllRequiredFieldsFilled(areAllRequiredFieldsFilled);

        let tableauDataTmp = [...tableauData];
        tableauDataTmp.forEach((el) => {
            const areAllRequiredFieldsFilledOfKey = requiredFields
                .filter((ele) => ele.key === el.key)
                .every((e) => {
                    if (typeof adherent[e.field] === "number") {
                        return adherent[e.field] > 0;
                    } else {
                        return (
                            adherent[e.field].trim() !== "" &&
                            (!e.longueur ||
                                (e.longueur && adherent[e.field].length === e.longueur))
                        );
                    }
                });
            el.requiredFieldsFilled = areAllRequiredFieldsFilledOfKey;
        });
        setTableauData(tableauDataTmp);
    };

    const isValidBICNumber = (input) => {
        var res =
            /^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test(
                input.toUpperCase()
            );
        return res;
    };

    //https://stackoverflow.com/questions/21928083/iban-validation-check
    const isValidIBANNumber = (input) => {
        var CODE_LENGTHS = {
            AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29, CH: 21, CR: 21, CY: 28, CZ: 24,
            DE: 22, DK: 18, DO: 28, EE: 20, ES: 24, FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21, HU: 28, IE: 22,
            IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28, LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
            MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29, RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27,
            TN: 24, TR: 26,
        };
        var iban = String(input)
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, ""), // keep only alphanumeric characters
            code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
            digits;
        // check syntax and length
        if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
            return false;
        }
        // rearrange country code and check digits, and convert chars to ints

        digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
            var res = letter.charCodeAt(0) - 55;
            return res.toString();
        });

        // digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
        //     return letter.charCodeAt(0) - 55;
        // });
        // final check
        return mod97(digits) === 1;
    };

    const mod97 = (string) => {
        var checksum = string.slice(0, 2),
            fragment;
        for (var offset = 2; offset < string.length; offset += 7) {
            fragment = String(checksum) + string.substring(offset, offset + 7);
            checksum = parseInt(fragment, 10) % 97;
        }
        return checksum;
    };

    const handleInputChangeDate = (field, value) => {
        // Vérifie si la date est au format valide ou vide ou null
        if (value === "" ||
            value === null ||
            moment(value, "YYYY-MM-DD", true).isValid() ||
            moment(value, "DD/MM/YYYY", true).isValid()
        ) {
            let newEditedAdherent = { ...editedAdherent, [field]: value };
            setEditedAdherent(newEditedAdherent);
            verifAllRequiredFieldsFilled(newEditedAdherent);
        }
    };

    const handleInputChange = (field, value) => {
        // console.log(field, value);

        let newEditedAdherent = { ...editedAdherent };
        // if (field === 'nbre_productifs') {
        //     newEditedAdherent = { ...editedAdherent, [field]: value, total_personnel: parseInt(value) + parseInt(editedAdherent.nbre_apprentis) };
        // } else if (field === 'nbre_apprentis') {
        //     newEditedAdherent = { ...editedAdherent, [field]: value, total_personnel: parseInt(value) + parseInt(editedAdherent.nbre_productifs) };
        // } else
        //code_postal')}
        //numero_de_dpt
        if (field === "has_tribu") {
            newEditedAdherent = {
                ...editedAdherent,
                [field]: value,
                tribu_montant: value === 1 ? cotisation.tribu_montant : 0,
            };
        } else if (field === "has_siv") {
            newEditedAdherent = {
                ...editedAdherent,
                [field]: value,
                siv_montant: value === 1 ? cotisation.siv_montant : 0,
            };
        } else if (["numero_de_portable", "telephone"].includes(field)) {
            const phoneNumber = value.replace(/\s/g, "");
            let formattedPhoneNumber = "";
            if (phoneNumber.length === 3)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{1})/, "$1 $2");
            else if (phoneNumber.length === 4)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{2})/, "$1 $2");
            else if (phoneNumber.length === 5)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{1})/,
                    "$1 $2 $3"
                );
            else if (phoneNumber.length === 6)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{2})/,
                    "$1 $2 $3"
                );
            else if (phoneNumber.length === 7)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{2})(\d{1})/,
                    "$1 $2 $3 $4"
                );
            else if (phoneNumber.length === 8)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{2})(\d{2})/,
                    "$1 $2 $3 $4"
                );
            else if (phoneNumber.length === 9)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{2})(\d{2})(\d{1})/,
                    "$1 $2 $3 $4 $5"
                );
            else if (phoneNumber.length === 10)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/,
                    "$1 $2 $3 $4 $5"
                );
            else formattedPhoneNumber = phoneNumber;
            newEditedAdherent = { ...editedAdherent, [field]: formattedPhoneNumber };
        } else if (field === "code_postal") {
            if (value.length === 5) { getCp(value); }
            newEditedAdherent = {
                ...editedAdherent,
                [field]: value,
                numero_de_dpt: value.length >= 2 ? value.substring(0, 2) : "",
            };
        } else if (field === "iban") {
            // console.log('iban', value, isValidIBANNumber(value));
            if (isValidIBANNumber(value))
                newEditedAdherent = {
                    ...editedAdherent,
                    [field]: value,
                    ibantmp: value,
                };
            else
                newEditedAdherent = { ...editedAdherent, [field]: value, ibantmp: "" };
        } else if (field === "bic") {
            // console.log('bic', value, isValidBICNumber(value));
            if (isValidBICNumber(value))
                newEditedAdherent = {
                    ...editedAdherent,
                    [field]: value,
                    bictmp: value,
                };
            else
                newEditedAdherent = { ...editedAdherent, [field]: value, bictmp: "" };
        } else {
            newEditedAdherent = { ...editedAdherent, [field]: value };
        }

        setEditedAdherent(newEditedAdherent);

        verifAllRequiredFieldsFilled(newEditedAdherent);
    };

    const getInputInvisible = (key, libelle, field) => {
        // console.log('getInput', field, [champs].includes(field));
        let champ = champs.find((el) => el.lib === field);
        if (!champ) return <></>;

        if (champ.required && !requiredFields.map((e) => e.field).includes(field))
            setRequiredFields([
                ...requiredFields,
                { field: field, longueur: champ.longueur, key: key },
            ]);

        return <></>;
    };

    const getInputInvisibleWithMessage = (key, libelle, field) => {
        // console.log('getInput', field, [champs].includes(field));
        let champ = champs.find((el) => el.lib === field);
        if (!champ) return <></>;

        let value = editedAdherent[field];

        if (champ.required && !requiredFields.map((e) => e.field).includes(field))
            setRequiredFields([
                ...requiredFields,
                { field: field, longueur: champ.longueur, key: key },
            ]);

        return (
            <>
                {value.length === 0 && (
                    <div>
                        <p style={{ color: "red" }}>Données incorrectes</p>
                    </div>
                )}
            </>
        );
    };

    const getInput = (key, libelle, field) => {
        // console.log('getInput', key, libelle, field);
        let champ = champs.find((el) => el.lib === field);
        if (!champ) return <></>;

        let value = editedAdherent[field];
        // console.log(value, typeof value, value.length, champ.longueur, value.length !== champ.longueur);
        if (champ.required && !requiredFields.map((e) => e.field).includes(field))
            setRequiredFields([
                ...requiredFields,
                { field: field, longueur: champ.longueur, key: key },
            ]);

        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        // console.log('getInput', key, libelle, field, value, champ, `Value = "${value}"`, value && value.trim() === '' ? 'has-error' : 'pas d`errreur');
        return (
            <>
                <InputGroup
                    className={`mb-3 ${champ.required &&
                        ((champ.longueur && value.length !== champ.longueur) ||
                            value.length === 0)
                        ? "has-error"
                        : ""
                        }`}
                    key={key + field}
                >
                    <InputGroup.Text
                        className={
                            champ.required &&
                                ((champ.longueur && value.length !== champ.longueur) ||
                                    value.length === 0)
                                ? "border-danger"
                                : ""
                        }
                    >
                        {libelle}
                        {champ.required && <span style={{ color: "red" }}>&nbsp;*</span>}
                    </InputGroup.Text>
                    <FormControl
                        value={value}
                        onChange={(e) => handleInputChange(field, e.target.value)}
                        maxLength={champ.longueur}
                    />
                </InputGroup>
                {champ.longueur && value.length !== champ.longueur && (
                    <div>
                        {/* Add a message to inform that required fields are mandatory */}
                        <p style={{ color: "red" }}>
                            Ce champ doit faire {champ.longueur} caractères
                        </p>
                    </div>
                )}
            </>
        );
    };

    const getInputNumber = (key, libelle, field) => {
        let value = editedAdherent[field];

        //Tous les champs number sont obligatoires (pas vide)
        let champ = champs.find((el) => el.lib === field);
        if (!champ) return <></>;
        if (champ.required && !requiredFields.map((e) => e.field).includes(field))
            setRequiredFields([
                ...requiredFields,
                { field: field, longueur: champ.longueur, key: key },
            ]);

        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        return (
            <InputGroup className={`mb-3 ${value === '' ? "has-error" : ""}`}
                key={field}>
                <InputGroup.Text className={value === '' ? "border-danger" : ""}>{libelle}</InputGroup.Text>
                <FormControl
                    min="0"
                    type="number"
                    value={value === 0 ? "" : value}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                />
            </InputGroup>
        );
    };

    const getDate = (libelle, field) => {
        let value = editedAdherent[field];
        // console.log('getDate', libelle, field, value)
        return (
            <InputGroup className="mb-3" key={field}>
                <InputGroup.Text>{libelle}</InputGroup.Text>
                <FormControl
                    type="date"
                    value={value}
                    onChange={(e) => handleInputChangeDate(field, e.target.value)}
                />
            </InputGroup>
        );
    };

    const getYesNo = (libelle, field) => {
        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        let value = editedAdherent[field];
        return (
            <InputGroup className="mb-3" key={field} width="100%">
                <InputGroup.Text className="flex-grow-1">{libelle}</InputGroup.Text>
                <ToggleButton
                    id={"toggle-check-oui" + field}
                    type="checkbox"
                    variant={value === 1 ? "success" : "outline-success"} // 'light' pour la variante "Non"
                    checked={value === 1}
                    onChange={(e) => handleInputChange(field, 1)}
                >
                    Oui
                </ToggleButton>

                <ToggleButton
                    id={"toggle-check-non" + field}
                    type="checkbox"
                    variant={value === 0 ? "danger" : "outline-danger"} // 'light' pour la variante "Oui"
                    checked={value === 0}
                    onChange={(e) => handleInputChange(field, 0)}
                >
                    Non
                </ToggleButton>
            </InputGroup>
        );
    };

    const getYesNoVisu = (libelle, field) => {
        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        let value = editedAdherent[field];
        return (
            <InputGroup className="mb-3" key={field} width="100%">
                <InputGroup.Text className="flex-grow-1">{libelle}</InputGroup.Text>
                <ToggleButton
                    id={"toggle-check" + field}
                    type="checkbox"
                    variant={value === 1 ? "success" : "danger"}
                    checked={value === 1}
                    value={value}
                >
                    {value === 1 ? "Oui" : "Non"}
                </ToggleButton>
            </InputGroup>
        );
    };

    const getSelect = (libelle, field, options) => {
        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        return (
            <InputGroup className="mb-3" key={field}>
                <InputGroup.Text>{libelle}</InputGroup.Text>
                <Form.Select
                    value={editedAdherent[field]}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                >
                    {options.map((item, index) => (
                        <option key={index} value={item}>
                            {item}
                        </option>
                    ))}
                </Form.Select>
            </InputGroup>
        );
    };

    const handleNewType = (field, value) => {
        setDropdown(JSON.parse(localStorage.getItem("dropdown")));
        handleInputChange(field, value);
    };

    const getSelectAndAdd = (libelle, field, options, type) => {
        // console.log('getSelectAndAdd', libelle, field, options, type);
        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        return (
            <InputGroup className="mb-3" key={field}>
                <InputGroup.Text>{libelle}</InputGroup.Text>
                <Form.Select
                    value={editedAdherent[field]}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                >
                    {options.map((item, index) => (
                        <option key={index} value={item}>
                            {item}
                        </option>
                    ))}
                </Form.Select>
                <NewDropdown type={type} field={field} handleNewType={handleNewType} />
            </InputGroup>
        );
    };

    const handleChoixCotisation = (e, nbfois) => {
        saveChoixCotisation(e, nbfois);
        setCotisation({
            ...cotisation,
            choix_id: e.id,
            paiement_en_x_fois: nbfois,
        });
        if (JSON.stringify(cotisation2) !== "{}")
            setCotisation2({
                ...cotisation2,
                choix_id: 0,
                paiement_en_x_fois: nbfois,
            });
    };

    const handleChoixCotisation2 = (e, nbfois) => {
        saveChoixCotisation(e, nbfois);
        setCotisation2({
            ...cotisation2,
            choix_id: e.id,
            paiement_en_x_fois: nbfois,
        });
        setCotisation({ ...cotisation, choix_id: 0, paiement_en_x_fois: nbfois });
    };

    const saveChoixCotisation = (e, nbfois) => {
        console.log("saveChoixCotisation", e, nbfois, e.montant);
        let newEditedAdherent = {
            ...editedAdherent,
            cotisation_id: e.cotisation_id,
            choix_id: e.id,
            paiement_en_x_fois: nbfois,
            cotisation_nationale_t1: e.montant ? e.montant : 0,
        };
        setEditedAdherent(newEditedAdherent);

        verifAllRequiredFieldsFilled(newEditedAdherent);
    };

    const tableauData1 = [
        {
            key: "infoAdh",
            libelle: "Informations adhérent",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {/* numero_client */}
                    {getInput("infoAdh", "Numéro client", "numero_client")}
                    {champs.find((el) => el.lib === "civilite") &&
                        getSelect(
                            "Civilité",
                            "civilite",
                            dropdown
                                .filter((el) => el.type === "civilite")
                                .map((el) => el.libelle)
                        )}
                    {getInput("infoAdh", "Prénom", "prenom_adherent")}
                    {getInput("infoAdh", "Nom", "nom_adherent")}
                    {getInput("infoAdh", "Adresse 1", "adresse1")}
                    {getInput("infoAdh", "Adresse 2", "adresse2")}
                    {getInput("infoAdh", "Code Postal", "code_postal")}
                    {getInput("infoAdh", "Ville", "ville")}
                    {getInput("infoAdh", "Téléphone 1", "telephone")}
                    {getInput("infoAdh", "Téléphone 2", "numero_de_portable")}
                    {getInput("infoAdh", "E-mail du service comptabilité", "e_mail_1")}
                    {getInput("infoAdh", "E-mail tribu", "e_mail_2")}
                    {getInput("infoAdh", "E-mail 3", "e_mail_3")}
                    {getSelect(
                        "Région",
                        "region",
                        dropdown
                            .filter((el) => el.type === "region")
                            .map((el) => el.libelle)
                    )}
                </>
            ),
        },
        {
            key: "infoAdhWaiting",
            libelle: "Informations adhérent",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {champs.find((el) => el.lib === "civilite") &&
                        getSelect(
                            "Civilité",
                            "civilite",
                            dropdown
                                .filter((el) => el.type === "civilite")
                                .map((el) => el.libelle)
                        )}
                    {getInput("infoAdhWaiting", "Prénom", "prenom_adherent")}
                    {getInput("infoAdhWaiting", "Nom", "nom_adherent")}
                    {getInput("infoAdhWaiting", "Adresse 1", "adresse1")}
                    {getInput("infoAdhWaiting", "Adresse 2", "adresse2")}
                    {getInput("infoAdhWaiting", "Code Postal", "code_postal")}
                    {getInput("infoAdhWaiting", "Ville", "ville")}
                    {getInput("infoAdhWaiting", "Téléphone 1", "telephone")}
                    {getInput("infoAdhWaiting", "Téléphone 2", "numero_de_portable")}
                    {getInput(
                        "infoAdhWaiting",
                        "E-mail du service comptabilité",
                        "e_mail_1"
                    )}
                    {getInput("infoAdhWaiting", "E-mail tribu", "e_mail_2")}
                    {getInput("infoAdhWaiting", "E-mail 3", "e_mail_3")}
                    {/* {getSelect('Région', 'region', dropdown.filter(el => el.type === 'region').map(el => (el.libelle)))} */}
                </>
            ),
        },
        {
            key: "entreprise",
            libelle: "Entreprise",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getInput("entreprise", "Entreprise", "nom_de_l_entreprise")}
                    {getInput("entreprise", "Siret", "siret")}
                    {getInput("entreprise", "Numéro TVA Intracommunautaire", "numero_tva_intracommunautaire")}
                    {getSelect("Code APE ou NAF", "code_ape_ou_naf", dropdown.filter((el) => el.type === "ape").map((el) => el.libelle))}
                    {getSelect("Forme Juridique", "forme_juridique_de_la_societe",
                        dropdown
                            .filter((el) => el.type === "societe")
                            .map((el) => el.libelle)
                    )}
                    {getInputNumber("entreprise", "Montant du Capital", "montant_du_capital")}
                    {getSelect("Métier", "code_metier",
                        dropdown
                            .filter((el) => el.type === "metier")
                            .map((el) => el.libelle)
                    )}
                    {/* {getInput('entreprise', 'Code Métier', 'code_metier')} */}
                </>
            ),
        },
        {
            key: "effectif",
            libelle: "Effectif",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getInputNumber("effectif", "Nombre Productifs affectés à l'atelier", "nbre_productifs")}
                    {getInputNumber("effectif", "Nombre Apprentis", "nbre_apprentis")}
                    {getInputNumber("effectif", "Total Personnel", "total_personnel")}
                    {/* {getText('Total Personnel', 'total_personnel')} */}
                </>
            ),
        },
        {
            key: "abonnement_visualisation",
            libelle: "Abonnement (non modifiable)",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getYesNoVisu(
                        "Accès Site FFC Newsletter",
                        "acces_site_ffc_newsletter"
                    )}
                    {/* {getInput('abonnement_visualisation', 'Accès Site FFC Newsletter', 'acces_site_ffc_newsletter', editedAdherent.acces_site_ffc_newsletter)} */}
                    {getYesNoVisu("Abonné FFC Experts", "abonne_ffc_expert")}
                    {getYesNoVisu("Abonné Mag Carrosserie", "abonne_mag_carrosserie")}
                    {getYesNoVisu(
                        "Abonné Profession Carrossier",
                        "abonne_profession_carrossier"
                    )}
                    {getYesNoVisu(
                        "Accès Médiateur Consommation",
                        "acces_mediateur_consommation"
                    )}
                </>
            ),
        },
        {
            key: "abonnement",
            libelle: "Abonnement",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {/* {getInput('abonnement', 'Accès Site FFC Newsletter', 'acces_site_ffc_newsletter', editedAdherent.acces_site_ffc_newsletter)} */}
                    {getYesNo("Abonné FFC Experts", "abonne_ffc_expert")}
                    {getYesNo("Abonné Mag Carrosserie", "abonne_mag_carrosserie")}
                    {getYesNo(
                        "Abonné Profession Carrossier",
                        "abonne_profession_carrossier"
                    )}
                    {getYesNo("Accès Site FFC Newsletter", "acces_site_ffc_newsletter")}
                    {getDate("Date enregistrement site FFC", "enregistre_site_ffc")}
                    {getYesNo(
                        "Accès Médiateur Consommation",
                        "acces_mediateur_consommation"
                    )}
                    {getDate(
                        "Date enregistrement site médiation",
                        "enregistre_site_mediation"
                    )}
                </>
            ),
        },
        {
            key: "adhesion",
            libelle: "Adhésion",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getSelectAndAdd(
                        "Réseau",
                        "reseau",
                        [
                            "",
                            ...dropdown
                                .filter((el) => el.type === "reseau")
                                .map((el) => el.libelle),
                        ],
                        "reseau"
                    )}
                    {getInputNumber("adhesion", "Adhérent Depuis", "adh_depuis")}
                    {getInputNumber("adhesion", "Année de Cotisation", "annee_de_cotisation")}
                    {getDate("Date de Paiement", "date_paiement")}
                    {getInputNumber("adhesion", "Cotisation Nationale", "cotisation_nationale_t1")}
                    {getInputNumber("adhesion", "Cotisation Réseau", "cotisation_reseau")}
                    {getInputNumber("adhesion", "Cotisation Régionale", "cotisation_regionale")}
                    {getInput("adhesion", "Cotisation 3 Ans", "cotisation_3_ans")}
                    {getSelect(
                        "Mode de Paiement",
                        "mode_de_paiement",
                        dropdown
                            .filter((el) => el.type === "paiement")
                            .map((el) => el.libelle)
                    )}
                    {getSelect("Paiement en X Fois", "paiement_en_x_fois", ["1", "2", "3", "4", "5", "6",])}
                    {/* {getInputNumber('Paiement en X Fois', 'paiement_en_x_fois')} */}
                    {getInput("adhesion", "CNPA", "cnpa")}
                    {getInput("adhesion", "FNAA", "fnaa")}
                    {getInput("adhesion", "Autre", "autre")}
                    {/* {getInput('adhesion', 'Choix Cotisa tion', 'cotisation_id')} */}
                </>
            ),
        },
        {
            key: "cotisation",
            libelle: "Cotisation",
            requiredFieldsFilled: true,
            corps: (
                <>
                    <CotisationSel
                        handleChoixCotisation={handleChoixCotisation}
                        closemodal={() => console.log("fermé")}
                        cotisationIdSel={editedAdherent.cotisation_id}
                        choixIdSel={editedAdherent.choix_id}
                    />
                    {/* <CotisationChoixSel handleChoixCotisation={handleChoixCotisation} cotisation={cotisation} closemodal={() => { console.log('fermé') }} /> */}
                </>
            ),
        },
        {
            key: "tribu",
            libelle: "Tribu",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getYesNo("Abonné Tribu", "has_tribu")}
                    {getDate("Date de Règlement", "date_de_reglement")}
                    {getDate("Fin Période", "fin_periode")}
                    {getInputNumber("tribu", "Montant Tribu Réglé", "montant_tribu_regle_t2")}
                    {getSelect(
                        "Moyen de Paiement",
                        "moyen_de_paiement",
                        dropdown
                            .filter((el) => el.type === "paiement")
                            .map((el) => el.libelle)
                    )}
                    {getSelect("Paiement en X Fois", "paiement_en_x_fois", [
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                    ])}
                    {/* {getInput('tribu', 'Paiement en X Fois', 'paiement_en_x_fois')} */}
                    {getInput("tribu", "Identifiant Tribu", "identifiant_tribu")}
                </>
            ),
        },
        {
            key: "siv",
            libelle: "SIV",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getYesNo("Abonné SIV", "has_siv")}
                    {getDate("Date de Règlement SIV", "date_de_reglement_siv")}
                    {getDate("Fin Période SIV", "fin_periode_siv")}
                    {getInputNumber("siv", "Montant SIV Réglé", "montant_regle_siv")}
                    {getSelect(
                        "Moyen de Paiement SIV",
                        "moyen_de_paiement_siv",
                        dropdown
                            .filter((el) => el.type === "paiement")
                            .map((el) => el.libelle)
                    )}
                    {getSelect("Paiement en X Fois SIV", "paiement_en_x_fois_siv", [
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                    ])}
                </>
            ),
        },
        {
            key: "membre",
            libelle: "Membre",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getYesNo("Membre Bureau FFC", "membre_bureau_ffc")}
                    {getYesNo("Membre Conseil National", "membre_conseil_national")}
                    {getYesNo("Membres Conseil Admin", "membres_conseil_admin")}
                    {getInput("membre", "Titre", "titre")}
                </>
            ),
        },
        {
            key: "cotisation_new_adherent",
            libelle: "Adhésion",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {cotisation.tribu_montant > 0 && (
                        <>
                            {getYesNo(
                                `Accès à la cession de créance « TRIBU », l'assistance aux règlements et l'envoi de courriers via Clearbus au prix de ${cotisation.tribu_montant} €`,
                                "has_tribu"
                            )}
                            <hr />
                        </>
                    )}
                    {cotisation.siv_montant > 0 && (
                        <>
                            {getYesNo(
                                `Accès au service « SIV » au prix de ${cotisation.siv_montant} €`,
                                "has_siv"
                            )}
                            <hr />
                        </>
                    )}
                    {getInputInvisible("cotisation_new_adherent", "Choix ID", "choix_id")}
                    {cotisation && cotisation.id !== 10 && (
                        <>
                            <h3>{cotisation.libelle}</h3>
                            <CotisationChoixSel
                                handleChoixCotisation={handleChoixCotisation}
                                cotisation={cotisation}
                                closemodal={() => {
                                    console.log("fermé");
                                }}
                            />
                        </>
                    )}

                    {JSON.stringify(cotisation2) !== "{}" && (
                        <>
                            <hr />
                            <h3>Bénéficier de 6 mois offerts en adhérant pour 3ans</h3>
                            <CotisationChoixSel
                                handleChoixCotisation={handleChoixCotisation2}
                                cotisation={cotisation2}
                                closemodal={() => {
                                    console.log("fermé");
                                }}
                            />
                        </>
                    )}
                </>
            ),
        },
        {
            key: "iban",
            libelle: "Prélèvement SEPA",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {champs.find((el) => el.lib === "civilite") &&
                        getSelect(
                            "Civilité",
                            "civilite",
                            dropdown
                                .filter((el) => el.type === "civilite")
                                .map((el) => el.libelle)
                        )}
                    {getInput("iban", "Prénom", "prenom_adherent")}
                    {getInput("iban", "Nom", "nom_adherent")}
                    {getInput("iban", "Adresse 1", "adresse1")}
                    {getInput("iban", "Adresse 2", "adresse2")}
                    {getInput("iban", "Code Postal", "code_postal")}
                    {getInput("iban", "Ville", "ville")}
                    {getInput("iban", "Téléphone", "telephone")}
                    {getInput("iban", "Iban", "iban")}
                    {getInputInvisibleWithMessage("iban", "Iban", "ibantmp")}
                    {getInput("iban", "BIC", "bic")}
                    {getInputInvisibleWithMessage("iban", "BIC", "bictmp")}
                    {getInput("iban", "RUM", "rum")}
                </>
            ),
        },
    ];

    // const tableauData = tableauData1.filter(el => blocs.includes(el.key));
    const [tableauData, setTableauData] = useState([]);

    useEffect(() => {
        setTableauData(tableauData1.filter((el) => blocs.includes(el.key)));
        if (activeKey === "") setActiveKey(blocs[0]);
    }, [blocs]);

    const renderModalContent = (data) => {
        return (
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between">
                        <h5>{data.libelle}</h5>
                    </div>
                </Card.Header>
                <Card.Body>{data.corps}</Card.Body>
            </Card>
        );
    };

    return (
        <>
            {champs.length > 0 && blocs.length > 0 && tableauData.length > 0 && (
                <div>
                    <Tab.Container
                        activeKey={activeKey}
                        onSelect={(key) => setActiveKey(key)}
                    >
                        {blocs.length > 1 && (
                            <Nav variant="tabs">
                                {tableauData.map((item, index) => (
                                    <Nav.Item key={index}>
                                        <Nav.Link eventKey={item.key}>
                                            {item.libelle}
                                            {!item.requiredFieldsFilled && (
                                                <div style={{ color: "red" }}>*</div>
                                            )}
                                        </Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                        )}
                        <Tab.Content>
                            {tableauData1.map((item, index) => (
                                <Tab.Pane eventKey={item.key}>
                                    {renderModalContent(item)}
                                </Tab.Pane>
                            ))}
                        </Tab.Content>
                    </Tab.Container>
                    <div style={{ marginBottom: "10px" }}>
                        {/* Add a message to inform that required fields are mandatory */}
                        <p style={{ color: "red" }}>
                            Les champs marqués d'une * sont obligatoires.
                        </p>
                    </div>
                    <div className="d-grid gap-2">
                        <Button
                            variant="primary"
                            size="lg"
                            onClick={saveAdherent}
                            disabled={!allRequiredFieldsFilled}
                        >
                            Enregistrer
                        </Button>
                    </div>
                </div>
            )}
            <Modal size="xl" show={showVilles} onHide={() => setShowVilles(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Villes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {villes.map((ville, index) => (
                        <div className="d-grid gap-2">
                            <Button className="outline-primary" key={index} onClick={() => handleVilleSelected(ville.localite)}>
                                {ville.localite}
                            </Button>
                        </div>
                    ))}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AdherentNewUpdate;
